import { jsxs as a, jsx as s } from "react/jsx-runtime";
import { Triggers as m } from "./triggers/Triggers.component.js";
import { Steps as g } from "./steps/Steps.component.js";
import * as c from "react";
import { useCallback as w } from "react";
import { S as E } from "../close-icon-DnaNTtVy.js";
import { Button as I } from "../shared/button/Button.component.js";
import { ButtonThemeEnum as x, ButtonSizeEnum as B } from "../shared/button/types.js";
import { useBoolean as T, useMergeThemeVariables as d } from "../shared/utils.js";
import { c as N } from "../index-C3-ZVs5E.js";
import { FlowRuns as M } from "./FlowRuns.component.js";
import '../assets/Flows.css';const S = "_button_t9gtm_2", k = "_container_t9gtm_256", C = "_canvas_t9gtm_731", D = "_sidebar_t9gtm_741", z = "_open_t9gtm_749", K = "_header_t9gtm_764", L = "_bugIcon_t9gtm_788", X = "_sidebarBody_t9gtm_798", e = {
  button: S,
  container: k,
  canvas: C,
  sidebar: D,
  open: z,
  header: K,
  bugIcon: L,
  sidebarBody: X
}, P = (n) => /* @__PURE__ */ c.createElement("svg", { fill: "#000000", height: "800px", width: "800px", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 432.458 432.458", xmlSpace: "preserve", ...n }, /* @__PURE__ */ c.createElement("g", { id: "XMLID_311_" }, /* @__PURE__ */ c.createElement("path", { id: "XMLID_835_", d: "M322.743,106.629c-2.778-4.518-5.731-8.889-8.873-13.08c-25.777-34.375-60.453-53.307-97.641-53.307 s-71.864,18.932-97.641,53.307c-3.143,4.191-6.095,8.562-8.874,13.08c20.061,31.973,60.275,53.85,106.514,53.85 C262.469,160.479,302.683,138.602,322.743,106.629z" }), /* @__PURE__ */ c.createElement("path", { id: "XMLID_1453_", d: "M417.458,201.755h-65.606c-0.808-12.567-2.625-24.87-5.406-36.742l51.575-51.576 c5.858-5.858,5.858-15.355,0-21.213c-5.857-5.858-15.355-5.858-21.213,0l-25.966,25.966c-7.348,12.845-17.202,24.674-29.365,35.028 c-24.637,20.972-56.246,33.718-90.248,36.621v202.376c31.443-4.39,60.365-22.55,82.641-52.255 c3.907-5.21,7.536-10.687,10.881-16.395l52.058,52.058c2.929,2.929,6.768,4.393,10.607,4.393c3.838,0,7.678-1.465,10.606-4.393 c5.858-5.858,5.858-15.355,0-21.213l-59.579-59.58c7.427-19.594,11.986-40.927,13.41-63.076h65.606c8.284,0,15-6.716,15-15 C432.458,208.471,425.742,201.755,417.458,201.755z" }), /* @__PURE__ */ c.createElement("path", { id: "XMLID_1457_", d: "M201.23,189.84c-34.003-2.903-65.612-15.649-90.249-36.621c-12.163-10.354-22.017-22.183-29.365-35.028 L55.65,92.224c-5.858-5.858-15.356-5.858-21.213,0c-5.858,5.858-5.858,15.355,0,21.213l51.575,51.575 c-2.78,11.873-4.598,24.175-5.406,36.742H15c-8.284,0-15,6.716-15,15c0,8.284,6.716,15,15,15h65.606 c1.424,22.149,5.983,43.482,13.41,63.076l-59.579,59.579c-5.858,5.858-5.858,15.355,0,21.213c5.857,5.858,15.355,5.858,21.213,0 l52.058-52.058c3.345,5.708,6.974,11.185,10.881,16.395c22.274,29.705,51.197,47.866,82.641,52.255V189.84z" }))), j = ({
  copies: n,
  declaration: t,
  apiDeclaration: i,
  onFlowDeclarationUpdate: r,
  queryFlowRuns: p,
  queryFlowRunLogs: h,
  theme: l
}) => {
  const [o, , , b] = T(!1), _ = t.debug ?? !1, u = w(
    (y) => {
      r({
        ...t,
        debug: y.currentTarget.checked
      });
    },
    [t, r]
  ), v = d(
    "triggers",
    m.themeKeys,
    l
  ), f = d("steps", g.themeKeys, l);
  return /* @__PURE__ */ a("div", { className: e.container, children: [
    /* @__PURE__ */ a("div", { className: e.canvas, children: [
      /* @__PURE__ */ s(
        m,
        {
          declaration: t,
          apiDeclaration: i,
          onFlowDeclarationUpdate: r,
          copies: n.triggers,
          theme: v
        }
      ),
      /* @__PURE__ */ s(
        g,
        {
          declaration: t,
          apiDeclaration: i,
          onFlowDeclarationUpdate: r,
          copies: n.steps,
          theme: f
        }
      )
    ] }),
    /* @__PURE__ */ a(
      "div",
      {
        className: N(e.sidebar, {
          [e.open]: o
        }),
        children: [
          /* @__PURE__ */ a("div", { className: e.header, children: [
            o && "Debugging Panel",
            /* @__PURE__ */ s(
              I,
              {
                size: B.sm,
                theme: x.naked,
                className: e.button,
                "aria-label": "Enable debugging",
                onClick: b,
                children: o ? /* @__PURE__ */ s(E, { className: e.bugIcon }) : /* @__PURE__ */ s(P, { className: e.bugIcon })
              }
            )
          ] }),
          o && /* @__PURE__ */ s("div", { className: e.sidebarBody, children: /* @__PURE__ */ s(
            M,
            {
              queryFlowRuns: p,
              queryFlowRunLogs: h,
              isDebuggingEnabled: _,
              onEnableDebugging: u
            }
          ) })
        ]
      }
    ),
    /* @__PURE__ */ s("div", { id: "graphapi-app-plate-root" })
  ] });
}, O = j;
O.themeKeys = {
  ...m.themeKeys,
  ...g.themeKeys,
  triggers: !0,
  steps: !0
};
export {
  O as Flows
};
